import { Box } from '@material-ui/core';
import Dialog from '../../../../components/Dialog';
import Text from '../../../../components/Text';
import { bedStatusAPI } from '../../../../apis';
import { bedstatusRef } from '../..';
import { ServiceTable } from '.';

const CancelServicePopup = ({ handleClose, handleConfirm, data, reminder }) => {
  const orderList = [data];

  const withdrawnCleansing = async () => {
    try {
      const params = {
        bsCleansingRequestId: [data?.bsCleansingRequestId],
      };
      await bedStatusAPI.withdrawnCleansing(params);
      handleConfirm();
      bedstatusRef?.current?.reload?.();
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <Dialog
      open
      title="Cancel service order confirmation"
      cancel="Cancel"
      confirm="Confirm"
      dialogfootStyle={{ marginTop: '2.5rem' }}
      handleClose={handleClose}
      handleCancel={handleClose}
      handleConfirm={withdrawnCleansing}
    >
      <Box display="flex" flexDirection="column">
        <Text color="#2E4469" mb="1.87rem">
          Are you sure to cancel the service order for {reminder}?
        </Text>
        <ServiceTable orderList={orderList} />
      </Box>
    </Dialog>
  );
};

export default CancelServicePopup;
